<template>
  <div id="userInfo" class="userInfo">
    <div style="background-color: #fff" v-if="this.isPass != 0">
      <p class="title">个人信息</p>
      <div class="userinfoContainer">
        <el-form label-width="100px">
          <el-form-item label="类型：">
            <span v-if="info.user_type == 2">个人开发者</span>
            <span v-else>企业开发者</span>
          </el-form-item>
          <div v-if="info.user_type == 2">
            <el-form-item label="姓名：">
              {{info.user_name}}
            </el-form-item>
            <el-form-item label="手机号：">
              {{info.user_phone}}
            </el-form-item>
            <el-form-item label="邮箱：">
              {{info.email}}
            </el-form-item>
            <el-form-item label="身份证号：">
              {{info.id_card}}
            </el-form-item>
            <el-form-item label="证件照：">
              <div style="width: 346px;height:148px;overflow: hidden">
                <el-upload
                  :action="uploadUrl()"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-success="uploadSuccess"
                  :file-list="fileList2"
                  :disabled="true"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" size="tiny">
                  <img width="100%" :src="dialogImageUrl" alt="img">
                </el-dialog>
              </div>
            </el-form-item>
          </div>
          <div v-if="info.user_type == 1">
            <el-form-item label="联系人：" prop="user_name">
              {{info.user_name}}
            </el-form-item>
            <el-form-item label="联系方式：" prop="often_contact_phone">
              {{info.often_contact_phone}}
            </el-form-item>
            <el-form-item label="公司名称："  prop="company_name">
              {{info.company_name}}
            </el-form-item>
            <el-form-item label="公司邮箱：" prop="email">
              {{info.email}}
            </el-form-item>
            <el-form-item label="营业号码：" prop="business_license">
              {{info.business_license}}
            </el-form-item>
            <el-form-item label="营业执照：">
              <div style="width: 346px;height:148px;overflow: hidden">
                <el-upload
                  :action="uploadUrl()"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-success="uploadSuccess"
                  :file-list="fileList2"
                  :disabled="true"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" size="tiny">
                  <img width="100%" :src="dialogImageUrl" alt="img">
                </el-dialog>
              </div>
            </el-form-item>
            <el-form-item label="公司简介：">
              <el-input
                type="textarea"
                :disabled="true"
                v-model="info.company_intro"
                :autosize="{ minRows: 6}">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div v-else>
      <p class="title">身份信息</p>
      <div style="width: 315px;text-align: center;margin: 30px 0 20px 30px">
        <p>请完成身份认证，认证以后将享受更多功能与服务</p>
        <el-button type="primary" style="border-radius: 20px" @click="toDeveloper">开发者认证</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import {examineApi} from '@/api'
  import config from '@/config/index'

  export default {
    data() {
      return {
        fileList2: [],
        dialogImageUrl: '',
        dialogVisible: false,
        isPass: '',
        info: {
          user_type: '',
          user_phone: '',
          user_name: '',
          email: '',
          pic_url: [],
          id_card: '',
          company_name: '',
          company_intro: '',
          product_intro: '',
          authorization: ''
        }
      }
    },
    created() {
      this.examine()
    },
    methods: {
      toDeveloper(){
        this.$router.push('/developer');
      },
      uploadUrl() {//动态写入图片地址
        return `${config.host}/user/upload`
      },
      handleRemove(file, fileList) {
        this.info.pic_url = this.info.pic_url.filter(item => {
          return file.response.data.url != item
        })
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      uploadSuccess(res, file, fileList) {
        this.info.pic_url.push(res.data.url)
      },
      async examine() {
//        -1 冻结，0 未审核，1 审核不通过，2 审核通过
        let res = await examineApi()
        if (res.data.code == 200) {
          if (res.data.data.user_type) {
            this.isPass = res.data.data.status
            this.info = res.data.data
            this.info.pic_url.forEach(item => {
              this.fileList2.push({url: item})
            })
          }
        } else if (res.data.code == 401) {
          window.location.href('/login')
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  .userInfo {
    background: #fff;
    height: 100%;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-weight: 900;
      font-size: 18px;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .userinfoContainer {
      padding: 20px;
    }
    .el-upload {
      overflow: hidden;
    }
    .el-upload--picture-card{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/UserInfo.vue